var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"baseValueCircle"},[_c('canvas',{ref:"circle",attrs:{"width":"50","height":"50"}}),_c('div',{staticClass:"valueLabel"},[_c('div',[_vm._v(_vm._s(this.value + ' ' + this.unit))])])])}
var staticRenderFns = []

export { render, staticRenderFns }